import React from 'react';

interface Service {
  title: string;
  description: string;
  features: string[];
}

const services: Service[] = [
  {
    title: 'Payment Processing',
    description: 'Accept payments from customers worldwide with our secure payment gateway.',
    features: [
      'Credit & Debit Cards',
      'Digital Wallets',
      'Bank Transfers',
      'Cryptocurrency',
    ],
  },
  {
    title: 'Merchant Solutions',
    description: 'Complete merchant account solutions tailored to your business needs.',
    features: [
      'Quick Setup',
      'Competitive Rates',
      '24/7 Support',
      'Custom Integration',
    ],
  },
  {
    title: 'API Integration',
    description: 'Powerful APIs to integrate payment processing into your applications.',
    features: [
      'RESTful API',
      'SDKs Available',
      'Webhooks',
      'Developer Docs',
    ],
  },
];

const Services: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive payment solutions designed for businesses of all sizes.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow"
            >
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <svg
                      className="w-5 h-5 text-blue-600 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
